import { render, staticRenderFns } from "./shangYeXian.vue?vue&type=template&id=30db0bf2&scoped=true&"
import script from "./shangYeXian.vue?vue&type=script&lang=js&"
export * from "./shangYeXian.vue?vue&type=script&lang=js&"
import style0 from "./shangYeXian.vue?vue&type=style&index=0&id=30db0bf2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30db0bf2",
  null
  
)

export default component.exports